/* -----------------Globals--------------- */
import Icon from "@react-native-vector-icons/material-design-icons/static";
/* -----------------UI--------------- */
import { List } from "react-native-paper";

import { useAppTheme } from "../../useAppTheme";
/* -----------------Helpers & Hooks--------------- */
import ProductIcon from "../ProductIcon";

export const ExamContextListItem = ({
	title,
	icon,
	hasMoreThanOneExam,
	handleNavigateToExamsRoute,
}: {
	title: string;
	icon?: string;
	hasMoreThanOneExam?: boolean;
	handleNavigateToExamsRoute: () => void;
}) => {
	const theme = useAppTheme();
	const leftIcon = () => {
		if (!icon?.includes(".")) {
			return (
				<Icon
					name={
						(icon ?? "file-document-outline") as React.ComponentProps<
							typeof Icon
						>["name"]
					}
					size={24}
					color={theme.colors.onSurfaceVariant}
				/>
			);
		}
		return <ProductIcon image={icon} size={34} />;
	};
	return (
		<>
			<List.Item
				style={{
					paddingVertical: 0,
					paddingHorizontal: 16,
				}}
				onPress={hasMoreThanOneExam ? handleNavigateToExamsRoute : undefined}
				title={title}
				right={(p) => {
					return hasMoreThanOneExam ? (
						<List.Icon
							{...p}
							icon={(props) => <Icon {...props} name="swap-horizontal" />}
						/>
					) : null;
				}}
				titleStyle={{
					...theme.typography.fonts.medium,
				}}
				left={leftIcon}
			/>
		</>
	);
};
